import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'

import { QUERY_KEYS } from '@api'

import { addNote } from './api'

const onError = () => {
  notification.error({
    message: 'Error al guardar la nota',
  })
}

const useNote = () => {
  const queryClient = useQueryClient()
  const { mutate, isLoading } = useMutation(addNote, {
    onSuccess: () => {
      queryClient.refetchQueries([QUERY_KEYS.TICKET])
    },
    onError,
  })

  return {
    addNote: mutate,
    isLoading,
  }
}

export { useNote }
